import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import cart from './modules/cart'
import payment from './modules/payment'
import print from './modules/print'
import product from './modules/product'
import sellsukiData from './modules/sellsukiData'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'store',
  storage: localStorage
})

const store = () => {
  return new Vuex.Store({
    modules: {
      cart,
      payment,
      print,
      product,
      sellsukiData
    },
    plugins: [vuexLocalStorage.plugin]
  })
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js